/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type timesheetsTeam_viewer = {
    readonly component: string | null;
    readonly company: {
        readonly id: string;
    } | null;
    readonly " $refType": "timesheetsTeam_viewer";
};
export type timesheetsTeam_viewer$data = timesheetsTeam_viewer;
export type timesheetsTeam_viewer$key = {
    readonly " $data"?: timesheetsTeam_viewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"timesheetsTeam_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "timesheetsTeam_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "name",
          "value": "team-timesheet"
        }
      ],
      "kind": "ScalarField",
      "name": "component",
      "storageKey": "component(name:\"team-timesheet\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Company",
      "kind": "LinkedField",
      "name": "company",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer"
};
(node as any).hash = 'e5034a3c27cb49e198f62a9fdd3a5b64';
export default node;
